export default
{   testSubmissionCycleYear       : [],
    testRequestIdentifier         : [],
    suppliedMaterialIdentifier    : [],
    nikePPSItemNumber             : [],
    testSubmissionType            : [],
    nikeMsEndUse                  : [],
    materialType                  : [],
    supplierLocation              : [],
    testLabIdentifier             : [],
    labTestState                  : [],
    testSubmissionStatusIndicator : []
};



// WEBPACK FOOTER //
// ./src/Components/FiltersDefaultState.js